var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-select',_vm._g(_vm._b({attrs:{"label":_vm.label,"dense":_vm.dense,"items":_vm.companies,"item-text":_vm.itemText,"item-value":_vm.itemValue}},'app-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }